import { Component } from '@angular/core';

@Component({
  selector: 'app-security-approval',
  templateUrl: './security-approval.component.html',
  styleUrls: ['./security-approval.component.scss']
})
export class SecurityApprovalComponent {

}
